import * as React from 'react';
import * as moment from 'moment';
import numeral from 'numeral';
import ZoneSelect from '../../components/cart/zone-select';
import PwycAmountInput from '../../components/cart/pwyc-amount-input';
import { sumPrices } from '../../helpers/pricing-helpers';
import { CombineCartViewProps } from '../../components/cart/cart-item';

const CartItemView: React.StatelessComponent<CombineCartViewProps> = props => {

    function decodeHtmlEntities(text: string): string {
        const textarea = document.createElement('textarea');
        textarea.innerHTML = text;
        return textarea.value;
    }

    return (
        <li className="" key={props.itemId}>
            <div className="stack-sm">
                {
                    props.itemTitle ?
                        <div className="flex-between">
                            <p className="bold align-self-center">{decodeHtmlEntities(props.itemTitle)}</p>
                            {
                                props.showRemoveButton ?
                                    <button type="button" className="btn-primary" onClick={() => props.removeItem(props.itemIdToRemove)}>
                                        <span className="visually-hidden">{props.text.removeButtonText}</span>
                                        <span role="presentation">-</span>
                                    </button>
                                    : null
                            }
                        </div>
                        : null
                }
                <div className="no-margins">
                    <p className="small">{props.itemDateString} {props.itemTimeString}</p>
                    <p className="small">{props.itemFacility}</p>
                </div>
            </div>
            {
                props.isUnseated
                    ?
                    <ZoneSelect showPriceTypeError={true} itemId={props.itemId} selectedZone={props.selectedZone} />
                    : null
            }

            {
                props.selectedZoneId < 1 ? null
                    :
                    <div>
                        <button type="button" className="un-button hyperlink bold small" onClick={() => props.removeZone(props.itemId)}>
                            {props.text.changeZoneButtonText}
                        </button>
                    </div>
            }

            {/* AAC26-75 - Show PWYC amount inputs after zone is selected */}
            {
                props.isPwyc && props.selectedZone && props.selectedZoneId > 0
                    ? <PwycAmountInput
                        performanceId={props.itemId}
                        zoneId={props.selectedZoneId}
                        prices={props.selectedZone.prices}
                      />
                    : null
            }

            {
                props.itemProcessErrorMessage.length > 0 ?
                    <span className="field-validation-error">{props.itemProcessErrorMessage}</span>
                    : null
            }
        </li>
    );
}

export default CartItemView;